module.exports = __webpack_public_path__ + "img/no-project.ff1fd5cf.svg";